
export function init_infinityLoop () {
  const splide = new Splide('.splide', {
    type: 'loop',
    drag: true, //ドラッグ操作可否
    focus: 'center',
    perPage: 1, //8枚表示
    autoWidth: true,
    autoHeight: true,
    padding: { top: 0, bottom: 100 },
    gap: 0,
    arrows: false, //矢印表示設定
    pagination: false, //ページネーション表示設定
    breakpoints: {
      768: {
        gap: 0
      }
    },
    autoScroll: {
      speed: 0,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });
  splide.mount(window.splide.Extensions);
}
